import React from "react";
import { TableOptions, DataItem } from "./types";

const formatCurrency = (value?: string | number) => {
  const safeValue =
    typeof value === "string" ? parseFloat(value.replace(/\./g, "").replace(",", ".")) : value || 0;
  return (
    <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>
      {safeValue.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
    </div>
  );
};

const formatCNPJ = (cnpj: string) =>
  cnpj
    ? cnpj
        .replace(/\D/g, "")
        .replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5")
    : "";

export const buildColumns = (
  options: TableOptions,
  getColumnSearchProps: (dataIndex: string, title: string) => object,
  getColumnDateProps: (dataIndex: string) => object,
  getColumnCheckboxProps: (options: string[]) => object,
  onAjustesClick: (record: DataItem) => void
) => [
  {
    key: "statusPgto",
    title: "STATUS PGTO",
    dataIndex: "statusPgto",
    width: 150,
    ...getColumnCheckboxProps(options.statusPgtoOpcoes),
  },
  {
    key: "statusConciliacao",
    title: "STATUS CONCILIAÇÃO",
    dataIndex: "statusConciliacao",
    width: 180,
    ...getColumnCheckboxProps(options.statusConciliacaoOpcoes),
  },
  {
    key: "dataPgto",
    title: "DATA PGTO",
    dataIndex: "dataPgto",
    width: 130,
    render: (value: string | null) => {
      if (!value) return "-";
      const [year, month, day] = value.split("-");
      return `${day}/${month}/${year}`;
    },
    ...getColumnDateProps("dataPgto"),
  },
  {
    key: "adquirente",
    title: "ADQUIRENTE",
    dataIndex: "adquirente",
    width: 130,
    ...getColumnCheckboxProps(options.adquirentes),
  },
  {
    key: "bandeira",
    title: "BANDEIRA",
    dataIndex: "bandeira",
    width: 130,
    ...getColumnCheckboxProps(options.bandeiras),
  },
  {
    key: "valorPrevisto",
    title: "VLR PREVISTO",
    dataIndex: "valorPrevisto",
    width: 140,
    render: formatCurrency,
  },
  {
    key: "valorDepositado",
    title: "VLR DEPOSITADO",
    dataIndex: "valorDepositado",
    width: 150,
    render: formatCurrency,
  },
  {
    key: "diferenca",
    title: "DIFERENÇA",
    dataIndex: "diferenca",
    width: 130,
    render: (value?: string | number) => {
      const safeValue =
        typeof value === "string" ? parseFloat(value.replace(/\./g, "").replace(",", ".")) : value || 0;
      return (
        <div style={{ textAlign: "right", whiteSpace: "nowrap", color: safeValue < 0 ? "#e74c3c" : undefined }}>
          {safeValue.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
        </div>
      );
    },
  },
  {
    key: "banco",
    title: "BANCO",
    dataIndex: "banco",
    width: 120,
    ...getColumnCheckboxProps(options.bancos),
  },
  {
    key: "agencia",
    title: "AGÊNCIA",
    dataIndex: "agencia",
    width: 120,
    ...getColumnCheckboxProps(options.agencias),
  },
  {
    key: "conta",
    title: "CONTA",
    dataIndex: "conta",
    width: 120,
    ...getColumnCheckboxProps(options.contas),
  },
  {
    key: "empresa",
    title: "EMPRESA",
    dataIndex: "empresa",
    width: 180,
    ...getColumnCheckboxProps(options.empresas),
  },
  {
    key: "nomeGrupo",
    title: "NOME GRUPO",
    dataIndex: "nomeGrupo",
    width: 160,
  },
  {
    key: "cnpj",
    title: "CNPJ",
    dataIndex: "cnpj",
    width: 180,
    render: formatCNPJ,
    ...getColumnCheckboxProps(options.cnpjs),
  },
  {
    key: "ajustes",
    title: "AJUSTES",
    dataIndex: "ajustes",
    width: 130,
    render: (value: string | number | undefined, record: DataItem) => {
      const safeValue =
        typeof value === "string" ? parseFloat(value.replace(/\./g, "").replace(",", ".")) : value || 0;
      return (
        <div
          onClick={() => onAjustesClick(record)}
          title="Ver ajustes vinculados"
          style={{
            textAlign: "right",
            whiteSpace: "nowrap",
            color: "#1677ff",
            cursor: "pointer",
            textDecoration: "underline",
            fontWeight: 600,
          }}
        >
          {safeValue.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
        </div>
      );
    },
    ...getColumnSearchProps("ajustes", "Ajustes"),
  },
  {
    key: "justificativa",
    title: "JUSTIFICATIVA",
    dataIndex: "justificativa",
    width: 200,
    ...getColumnSearchProps("justificativa", "Justificativa"),
  },
];